/**
 * @desc userAgent를 이용한 모바일 여부를 판단하여 boolean을 반환합니다
 * @param ua userAgent
 * @returns
 */
export const uaIsMobile = (ua: string) => {
  const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return reg.test(ua);
};
